module.exports = __webpack_public_path__ + "img/avatar6.e1fa6af9.png";